import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { LayoutDashboard, BarChart3, ChevronDown, FileText, Star, Settings, Users } from 'lucide-react';
export function Dashboard() {
  return <div className="min-h-screen bg-brand-offwhite flex" data-id="element-289">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-brand-light flex flex-col fixed inset-y-0 left-0 z-40" data-id="element-290">
        {/* Logo */}
        <div className="h-16 flex items-center px-6 border-b border-brand-light" data-id="element-291">
          <a href="/" className="flex items-center gap-2" data-id="element-292">
            <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-6 w-6 brightness-0 opacity-80" data-id="element-293" />
            <span className="font-serif font-semibold text-brand-dark tracking-wide" data-id="element-294">
              Eaves Pro
            </span>
          </a>
        </div>

        {/* User Profile */}
        <div className="p-4 border-b border-brand-light" data-id="element-295">
          <button className="w-full flex items-center justify-between p-2 rounded-xl hover:bg-brand-offwhite transition-colors" data-id="element-296">
            <div className="flex items-center gap-3" data-id="element-297">
              <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-8 h-8 rounded-full object-cover border border-brand-light" data-id="element-298" />
              <span className="text-sm font-medium text-brand-dark" data-id="element-299">
                Marcus Chen
              </span>
            </div>
            <ChevronDown size={16} className="text-brand-muted" data-id="element-300" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1" data-id="element-301">
          <NavLink to="/admin" end className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-302">
            <LayoutDashboard size={18} data-id="element-303" />
            Profile
          </NavLink>
          <NavLink to="/admin/record" className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-304">
            <FileText size={18} data-id="element-305" />
            Record
          </NavLink>
          <NavLink to="/admin/reviews" className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-306">
            <Star size={18} data-id="element-307" />
            Reviews
          </NavLink>
          <NavLink to="/admin/insights" className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-308">
            <BarChart3 size={18} data-id="element-309" />
            Insights
          </NavLink>
          <NavLink to="/admin/account" className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-310">
            <Settings size={18} data-id="element-311" />
            Account
          </NavLink>
          <NavLink to="/admin/users" className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${isActive ? 'bg-brand-sage text-brand-forest font-medium' : 'text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite'}`} data-id="element-312">
            <Users size={18} data-id="element-313" />
            Users
          </NavLink>
        </nav>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 ml-64 min-h-screen" data-id="element-314">
        <Outlet data-id="element-315" />
      </main>
    </div>;
}